module.exports = __webpack_public_path__ + "static/media/x-button-polos.c0f9ac7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/x-button-polos.svg
// module id = 815
// module chunks = 0